import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { TypeId } from 'src_common/common/websocket2/type';

export const isArray = createGuard(t.array(t.unknown));
export const isSelectionTemplateField = createGuard(t.array(
    t.interface({
        slug: t.string,
        label: t.string
    })
));

const FieldIO = t.interface({
    value: t.string,
    label: t.string,
    slug: t.string
});

export type FieldType = t.TypeOf<typeof FieldIO>;

const CustomSelectionIO = t.interface({
    id: t.number,
    selection_type: t.string,
    star_value: t.number,
    image: t.string,
    description: t.string,
    color: t.string,
    fields: t.array(FieldIO),
});

export type CustomSelectionType = t.TypeOf<typeof CustomSelectionIO>;

const CustomSelectionsIO = t.interface({
    market_id: t.number,
    selection_type: t.string,
    selections: t.array(CustomSelectionIO)
});

export type CustomSelectionsType = t.TypeOf<typeof CustomSelectionsIO>;

const isCustomSelection = createGuard(CustomSelectionsIO);

export const decodeCustomSelections = (data: unknown): Array<CustomSelectionsType> => {
    const out: Array<CustomSelectionsType> = [];
    if (isArray(data)) {
        for (const item of data) {
            if (isCustomSelection(item)) {
                out.push(item);
            } else {
                console.error('Invalid event details', item);
            }
        }
    } else {
        console.error('Should be array', data);
    }
    return out;
};

const MarketIO = t.interface({
    id: t.string,
    displayOrder: t.number,
});

export type MarketTypeRaw = t.TypeOf<typeof MarketIO>;
export type MarketType = Omit<MarketTypeRaw, 'id'> & { id: TypeId.MarketId };

const StarValueIO = t.interface({
    name: t.string,
    value: t.number,
});

export type StarValueType = t.TypeOf<typeof StarValueIO>;

const MarketFilterIO = t.interface({
    slug: t.string,
    label: t.string,
    displayOrder: t.number,
    markets: t.array(MarketIO),
    description: t.string,
    starValues: t.array(StarValueIO)
});

type MarketFilterTypeRaw = t.TypeOf<typeof MarketFilterIO>;

export type MarketFilterType = Omit<MarketFilterTypeRaw, 'markets'> & {
    markets: Array<{
        id: TypeId.MarketId,
        displayOrder: number
    }>
};

export const isMarketFilter = createGuard(MarketFilterIO);
